module.exports = __webpack_public_path__ + "static/media/edinburgh-34.b995701f.jpg";